/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const ProfileParentRelationshipFragmentDoc = gql`
    fragment ProfileParentRelationship on ProfileRelationshipType {
  id
  parentProfileId
  relationshipType
  percentOwnership
}
    `;
export const ProfileRulesEngineFragmentDoc = gql`
    fragment ProfileRulesEngine on DocumentRulesEngineType {
  documentTypes {
    baseType
    subType
    status
    isMandatory
  }
}
    `;
export const ProfileDocumentFragmentDoc = gql`
    fragment ProfileDocument on DocumentType {
  expiryDate
  documentPurpose {
    baseType
  }
  metadata {
    key
    value
  }
}
    `;
export const ProfileTreeProfileDetailsFragmentDoc = gql`
    fragment ProfileTreeProfileDetails on ProfileType {
  id
  complianceObjectType
  accountType
  firstName
  middleName
  lastName
  legalName
  dateOfBirth
  amlEntityTypeId
  caseDataEntryStatus(caseId: $caseId) {
    ownersCompleted
    controllersCompleted
    documentsCompleted
  }
  parentRelationships {
    ...ProfileParentRelationship
  }
  rulesEngine(caseId: $caseId) {
    ...ProfileRulesEngine
  }
  documents {
    ...ProfileDocument
  }
}
    ${ProfileParentRelationshipFragmentDoc}
${ProfileRulesEngineFragmentDoc}
${ProfileDocumentFragmentDoc}`;
export const PositionProfileFragmentDoc = gql`
    fragment PositionProfile on ProfileType {
  id
  firstName
  middleName
  lastName
  legalName
  accountType
  complianceObjectType
  parentRelationships {
    parentProfileId
    relationshipType
    percentOwnership
  }
  riskRating {
    calculatedRating
    overriddenRating
  }
}
    `;
export const DocumentsDetailsFragmentDoc = gql`
    fragment DocumentsDetails on DocumentType {
  id
  name
  s3Link
  profileId
  expiryDate
  createdAt
  documentPurpose {
    baseType
  }
  metadata {
    key
    value
    type
  }
  invitedUserDetails {
    emailAddress
  }
}
    `;
export const ProfileDetailsFragmentDoc = gql`
    fragment ProfileDetails on ProfileType {
  id
  path
  accountType
  complianceObjectType
  firstName
  middleName
  lastName
  legalName
  dateOfOrganization
  dateOfBirth
  amlEntityTypeId
  taxIdType
  taxIdUnencrypted
  taxIdUnencryptedLast4Digits
  addresses {
    id
    street
    street2
    city
    state {
      id
      code
    }
    province
    postalCode
    country {
      id
      alpha2code
    }
  }
  amlEntityTypeQuestions(caseId: $caseId) {
    id
    text
    subText
    isDefault
    targetAmlEntityTypeId
  }
  caseDataEntryStatus(caseId: $caseId) {
    ownersCompleted
    controllersCompleted
    documentsCompleted
  }
}
    `;
export const ProfileRelationshipDetailsFragmentDoc = gql`
    fragment ProfileRelationshipDetails on ProfileRelationshipType {
  id
  parentProfileId
  childProfileId
  relationshipType
  percentOwnership
  title
  childProfile {
    ...ProfileDetails
  }
}
    ${ProfileDetailsFragmentDoc}`;
export const DocumentTypesDetailsFragmentDoc = gql`
    fragment DocumentTypesDetails on DocumentRulesEngineType {
  documentTypes {
    baseType
    subType
    status
    isMandatory
  }
}
    `;
export const MutationErrorFragmentFragmentDoc = gql`
    fragment MutationErrorFragment on MutationErrorResponse {
  __typename
  errorCode
  message
}
    `;
export const GetCountriesDocument = gql`
    query GetCountries {
  complianceCountries {
    id
    alpha2code
    name
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
// @ts-ignore
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountriesQuery | undefined, GraphqlTypes.GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>;
export const UpdateCaseProfileOwnersCompletedDocument = gql`
    mutation updateCaseProfileOwnersCompleted($caseId: Int!, $profileId: Int!, $ownersCompleted: Boolean) {
  updateCaseProfileOwnersOrControllersCompleted(
    caseId: $caseId
    profileId: $profileId
    ownersCompleted: $ownersCompleted
  )
}
    `;
export type UpdateCaseProfileOwnersCompletedMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateCaseProfileOwnersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersCompletedMutationVariables>;

/**
 * __useUpdateCaseProfileOwnersCompletedMutation__
 *
 * To run a mutation, you first call `useUpdateCaseProfileOwnersCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseProfileOwnersCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseProfileOwnersCompletedMutation, { data, loading, error }] = useUpdateCaseProfileOwnersCompletedMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      profileId: // value for 'profileId'
 *      ownersCompleted: // value for 'ownersCompleted'
 *   },
 * });
 */
export function useUpdateCaseProfileOwnersCompletedMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateCaseProfileOwnersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateCaseProfileOwnersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersCompletedMutationVariables>(UpdateCaseProfileOwnersCompletedDocument, options);
      }
export type UpdateCaseProfileOwnersCompletedMutationHookResult = ReturnType<typeof useUpdateCaseProfileOwnersCompletedMutation>;
export type UpdateCaseProfileOwnersCompletedMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateCaseProfileOwnersCompletedMutation>;
export type UpdateCaseProfileOwnersCompletedMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateCaseProfileOwnersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersCompletedMutationVariables>;
export const RemoveProfileFromCaseDocument = gql`
    mutation removeProfileFromCase($caseId: Int!, $profileId: Int!) {
  removeProfileFromCase(caseId: $caseId, profileId: $profileId) {
    id
  }
}
    `;
export type RemoveProfileFromCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>;

/**
 * __useRemoveProfileFromCaseMutation__
 *
 * To run a mutation, you first call `useRemoveProfileFromCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProfileFromCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProfileFromCaseMutation, { data, loading, error }] = useRemoveProfileFromCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useRemoveProfileFromCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>(RemoveProfileFromCaseDocument, options);
      }
export type RemoveProfileFromCaseMutationHookResult = ReturnType<typeof useRemoveProfileFromCaseMutation>;
export type RemoveProfileFromCaseMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveProfileFromCaseMutation>;
export type RemoveProfileFromCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>;
export const GetOwnersDocument = gql`
    query GetOwners($caseId: Int!) {
  complianceCase(caseId: $caseId) {
    id
    investingProfile {
      id
      rulesEngine(caseId: $caseId) {
        documentTypes {
          baseType
          subType
          status
          isMandatory
        }
      }
      beneficialOwners {
        id
        percentOwnership
        childProfile {
          id
          complianceObjectType
          firstName
          lastName
          middleName
          legalName
          addresses {
            street
            street2
            street3
            state {
              id
              name
            }
            country {
              id
              name
            }
          }
        }
      }
    }
    documents {
      id
      name
      profileId
      status
      documentPurposeId
      s3Link
      contentType
      invitedUserDetails {
        emailAddress
      }
      metadata {
        key
        value
        type
      }
      documentPurpose {
        baseType
        expires
        complianceObjectType
      }
    }
    profiles {
      id
      path
      complianceObjectType
      firstName
      middleName
      lastName
      legalName
      parentRelationships {
        id
        relationshipType
        title
      }
    }
  }
}
    `;

/**
 * __useGetOwnersQuery__
 *
 * To run a query within a React component, call `useGetOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnersQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetOwnersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables> & ({ variables: GraphqlTypes.GetOwnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>(GetOwnersDocument, options);
      }
export function useGetOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>(GetOwnersDocument, options);
        }
// @ts-ignore
export function useGetOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>;
export function useGetOwnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOwnersQuery | undefined, GraphqlTypes.GetOwnersQueryVariables>;
export function useGetOwnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>(GetOwnersDocument, options);
        }
export type GetOwnersQueryHookResult = ReturnType<typeof useGetOwnersQuery>;
export type GetOwnersLazyQueryHookResult = ReturnType<typeof useGetOwnersLazyQuery>;
export type GetOwnersSuspenseQueryHookResult = ReturnType<typeof useGetOwnersSuspenseQuery>;
export type GetOwnersQueryResult = Apollo.QueryResult<GraphqlTypes.GetOwnersQuery, GraphqlTypes.GetOwnersQueryVariables>;
export const UpdateControllersCompletedDocument = gql`
    mutation updateControllersCompleted($caseId: Int!, $profileId: Int!, $controllersCompleted: Boolean) {
  updateCaseProfileOwnersOrControllersCompleted(
    caseId: $caseId
    profileId: $profileId
    controllersCompleted: $controllersCompleted
  )
}
    `;
export type UpdateControllersCompletedMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateControllersCompletedMutation, GraphqlTypes.UpdateControllersCompletedMutationVariables>;

/**
 * __useUpdateControllersCompletedMutation__
 *
 * To run a mutation, you first call `useUpdateControllersCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateControllersCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateControllersCompletedMutation, { data, loading, error }] = useUpdateControllersCompletedMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      profileId: // value for 'profileId'
 *      controllersCompleted: // value for 'controllersCompleted'
 *   },
 * });
 */
export function useUpdateControllersCompletedMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateControllersCompletedMutation, GraphqlTypes.UpdateControllersCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateControllersCompletedMutation, GraphqlTypes.UpdateControllersCompletedMutationVariables>(UpdateControllersCompletedDocument, options);
      }
export type UpdateControllersCompletedMutationHookResult = ReturnType<typeof useUpdateControllersCompletedMutation>;
export type UpdateControllersCompletedMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateControllersCompletedMutation>;
export type UpdateControllersCompletedMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateControllersCompletedMutation, GraphqlTypes.UpdateControllersCompletedMutationVariables>;
export const GetAmlQuestionsByAccountTypeDocument = gql`
    query GetAmlQuestionsByAccountType($caseId: Int, $accountType: AccountTypeEnum) {
  complianceCase(caseId: $caseId) {
    investingProfile {
      id
      amlEntityTypeQuestions(caseId: $caseId, accountType: $accountType) {
        id
        text
        subText
        isDefault
        targetAmlEntityTypeId
      }
    }
    profiles {
      id
      amlEntityTypeQuestions(caseId: $caseId, accountType: $accountType) {
        id
        text
        subText
        isDefault
        targetAmlEntityTypeId
      }
    }
  }
}
    `;

/**
 * __useGetAmlQuestionsByAccountTypeQuery__
 *
 * To run a query within a React component, call `useGetAmlQuestionsByAccountTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmlQuestionsByAccountTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmlQuestionsByAccountTypeQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      accountType: // value for 'accountType'
 *   },
 * });
 */
export function useGetAmlQuestionsByAccountTypeQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>(GetAmlQuestionsByAccountTypeDocument, options);
      }
export function useGetAmlQuestionsByAccountTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>(GetAmlQuestionsByAccountTypeDocument, options);
        }
// @ts-ignore
export function useGetAmlQuestionsByAccountTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>;
export function useGetAmlQuestionsByAccountTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery | undefined, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>;
export function useGetAmlQuestionsByAccountTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>(GetAmlQuestionsByAccountTypeDocument, options);
        }
export type GetAmlQuestionsByAccountTypeQueryHookResult = ReturnType<typeof useGetAmlQuestionsByAccountTypeQuery>;
export type GetAmlQuestionsByAccountTypeLazyQueryHookResult = ReturnType<typeof useGetAmlQuestionsByAccountTypeLazyQuery>;
export type GetAmlQuestionsByAccountTypeSuspenseQueryHookResult = ReturnType<typeof useGetAmlQuestionsByAccountTypeSuspenseQuery>;
export type GetAmlQuestionsByAccountTypeQueryResult = Apollo.QueryResult<GraphqlTypes.GetAmlQuestionsByAccountTypeQuery, GraphqlTypes.GetAmlQuestionsByAccountTypeQueryVariables>;
export const UpdateIraAccountDocument = gql`
    mutation UpdateIraAccount($profileId: Int!, $metaData: JSON!, $caseId: Int!) {
  updateProfileMetaData(
    profileId: $profileId
    metaData: $metaData
    caseId: $caseId
  ) {
    id
  }
}
    `;
export type UpdateIraAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateIraAccountMutation, GraphqlTypes.UpdateIraAccountMutationVariables>;

/**
 * __useUpdateIraAccountMutation__
 *
 * To run a mutation, you first call `useUpdateIraAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIraAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIraAccountMutation, { data, loading, error }] = useUpdateIraAccountMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      metaData: // value for 'metaData'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useUpdateIraAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateIraAccountMutation, GraphqlTypes.UpdateIraAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateIraAccountMutation, GraphqlTypes.UpdateIraAccountMutationVariables>(UpdateIraAccountDocument, options);
      }
export type UpdateIraAccountMutationHookResult = ReturnType<typeof useUpdateIraAccountMutation>;
export type UpdateIraAccountMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateIraAccountMutation>;
export type UpdateIraAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateIraAccountMutation, GraphqlTypes.UpdateIraAccountMutationVariables>;
export const GetInvestorProfileForHybridDocument = gql`
    query GetInvestorProfileForHybrid($caseId: Int!) {
  complianceCase(caseId: $caseId) {
    id
    investingProfile {
      id
      firstName
      middleName
      lastName
      legalName
      metaData
    }
  }
}
    `;

/**
 * __useGetInvestorProfileForHybridQuery__
 *
 * To run a query within a React component, call `useGetInvestorProfileForHybridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestorProfileForHybridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestorProfileForHybridQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetInvestorProfileForHybridQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables> & ({ variables: GraphqlTypes.GetInvestorProfileForHybridQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>(GetInvestorProfileForHybridDocument, options);
      }
export function useGetInvestorProfileForHybridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>(GetInvestorProfileForHybridDocument, options);
        }
// @ts-ignore
export function useGetInvestorProfileForHybridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>;
export function useGetInvestorProfileForHybridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorProfileForHybridQuery | undefined, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>;
export function useGetInvestorProfileForHybridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>(GetInvestorProfileForHybridDocument, options);
        }
export type GetInvestorProfileForHybridQueryHookResult = ReturnType<typeof useGetInvestorProfileForHybridQuery>;
export type GetInvestorProfileForHybridLazyQueryHookResult = ReturnType<typeof useGetInvestorProfileForHybridLazyQuery>;
export type GetInvestorProfileForHybridSuspenseQueryHookResult = ReturnType<typeof useGetInvestorProfileForHybridSuspenseQuery>;
export type GetInvestorProfileForHybridQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestorProfileForHybridQuery, GraphqlTypes.GetInvestorProfileForHybridQueryVariables>;
export const UpdateCaseProfileOwnersOrControllersCompletedDocument = gql`
    mutation updateCaseProfileOwnersOrControllersCompleted($caseId: Int!, $profileId: Int!, $ownersCompleted: Boolean, $controllersCompleted: Boolean, $documentsCompleted: Boolean) {
  updateCaseProfileOwnersOrControllersCompleted(
    caseId: $caseId
    profileId: $profileId
    ownersCompleted: $ownersCompleted
    controllersCompleted: $controllersCompleted
    documentsCompleted: $documentsCompleted
  )
}
    `;
export type UpdateCaseProfileOwnersOrControllersCompletedMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutationVariables>;

/**
 * __useUpdateCaseProfileOwnersOrControllersCompletedMutation__
 *
 * To run a mutation, you first call `useUpdateCaseProfileOwnersOrControllersCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseProfileOwnersOrControllersCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseProfileOwnersOrControllersCompletedMutation, { data, loading, error }] = useUpdateCaseProfileOwnersOrControllersCompletedMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      profileId: // value for 'profileId'
 *      ownersCompleted: // value for 'ownersCompleted'
 *      controllersCompleted: // value for 'controllersCompleted'
 *      documentsCompleted: // value for 'documentsCompleted'
 *   },
 * });
 */
export function useUpdateCaseProfileOwnersOrControllersCompletedMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutationVariables>(UpdateCaseProfileOwnersOrControllersCompletedDocument, options);
      }
export type UpdateCaseProfileOwnersOrControllersCompletedMutationHookResult = ReturnType<typeof useUpdateCaseProfileOwnersOrControllersCompletedMutation>;
export type UpdateCaseProfileOwnersOrControllersCompletedMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutation>;
export type UpdateCaseProfileOwnersOrControllersCompletedMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutation, GraphqlTypes.UpdateCaseProfileOwnersOrControllersCompletedMutationVariables>;
export const BulkUnlinkChildProfilesDocument = gql`
    mutation bulkUnlinkChildProfiles($profileId: Int!, $caseId: Int!, $profileType: ProfileRelationshipEnum) {
  bulkUnlinkChildProfiles(
    profileId: $profileId
    caseId: $caseId
    profileType: $profileType
  )
}
    `;
export type BulkUnlinkChildProfilesMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkUnlinkChildProfilesMutation, GraphqlTypes.BulkUnlinkChildProfilesMutationVariables>;

/**
 * __useBulkUnlinkChildProfilesMutation__
 *
 * To run a mutation, you first call `useBulkUnlinkChildProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnlinkChildProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnlinkChildProfilesMutation, { data, loading, error }] = useBulkUnlinkChildProfilesMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      caseId: // value for 'caseId'
 *      profileType: // value for 'profileType'
 *   },
 * });
 */
export function useBulkUnlinkChildProfilesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkUnlinkChildProfilesMutation, GraphqlTypes.BulkUnlinkChildProfilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkUnlinkChildProfilesMutation, GraphqlTypes.BulkUnlinkChildProfilesMutationVariables>(BulkUnlinkChildProfilesDocument, options);
      }
export type BulkUnlinkChildProfilesMutationHookResult = ReturnType<typeof useBulkUnlinkChildProfilesMutation>;
export type BulkUnlinkChildProfilesMutationResult = Apollo.MutationResult<GraphqlTypes.BulkUnlinkChildProfilesMutation>;
export type BulkUnlinkChildProfilesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkUnlinkChildProfilesMutation, GraphqlTypes.BulkUnlinkChildProfilesMutationVariables>;
export const GetProfileActionInfoDocument = gql`
    query GetProfileActionInfo($caseId: Int!) {
  complianceCase(caseId: $caseId) {
    id
    investingProfile {
      id
      firstName
      middleName
      lastName
      legalName
      accountType
      complianceObjectType
      dateOfBirth
      amlEntityTypeId
      amlEntityTypeQuestions(caseId: $caseId) {
        id
        text
        subText
        isDefault
        targetAmlEntityTypeId
      }
      documents {
        ...DocumentsDetails
      }
      rulesEngine(caseId: $caseId) {
        documentTypes {
          baseType
          subType
          status
          isMandatory
        }
      }
      parentRelationships {
        id
        parentProfileId
        relationshipType
      }
      caseDataEntryStatus(caseId: $caseId) {
        id
        ownersCompleted
        controllersCompleted
        documentsCompleted
      }
    }
    profiles {
      id
      firstName
      middleName
      lastName
      legalName
      complianceObjectType
      accountType
      dateOfBirth
      amlEntityTypeId
      documents {
        ...DocumentsDetails
      }
      rulesEngine(caseId: $caseId) {
        documentTypes {
          baseType
          subType
          status
          isMandatory
        }
      }
      parentRelationships {
        id
        parentProfileId
        relationshipType
      }
      caseDataEntryStatus(caseId: $caseId) {
        id
        ownersCompleted
        controllersCompleted
        documentsCompleted
      }
    }
  }
}
    ${DocumentsDetailsFragmentDoc}`;

/**
 * __useGetProfileActionInfoQuery__
 *
 * To run a query within a React component, call `useGetProfileActionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileActionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileActionInfoQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetProfileActionInfoQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables> & ({ variables: GraphqlTypes.GetProfileActionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>(GetProfileActionInfoDocument, options);
      }
export function useGetProfileActionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>(GetProfileActionInfoDocument, options);
        }
// @ts-ignore
export function useGetProfileActionInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>;
export function useGetProfileActionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileActionInfoQuery | undefined, GraphqlTypes.GetProfileActionInfoQueryVariables>;
export function useGetProfileActionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>(GetProfileActionInfoDocument, options);
        }
export type GetProfileActionInfoQueryHookResult = ReturnType<typeof useGetProfileActionInfoQuery>;
export type GetProfileActionInfoLazyQueryHookResult = ReturnType<typeof useGetProfileActionInfoLazyQuery>;
export type GetProfileActionInfoSuspenseQueryHookResult = ReturnType<typeof useGetProfileActionInfoSuspenseQuery>;
export type GetProfileActionInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfileActionInfoQuery, GraphqlTypes.GetProfileActionInfoQueryVariables>;
export const GetProfilesHierarchyDocument = gql`
    query GetProfilesHierarchy($caseId: Int!) {
  complianceCase(caseId: $caseId) {
    id
    investingProfile {
      ...ProfileTreeProfileDetails
    }
    profiles {
      ...ProfileTreeProfileDetails
    }
  }
}
    ${ProfileTreeProfileDetailsFragmentDoc}`;

/**
 * __useGetProfilesHierarchyQuery__
 *
 * To run a query within a React component, call `useGetProfilesHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesHierarchyQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetProfilesHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables> & ({ variables: GraphqlTypes.GetProfilesHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>(GetProfilesHierarchyDocument, options);
      }
export function useGetProfilesHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>(GetProfilesHierarchyDocument, options);
        }
// @ts-ignore
export function useGetProfilesHierarchySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>;
export function useGetProfilesHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesHierarchyQuery | undefined, GraphqlTypes.GetProfilesHierarchyQueryVariables>;
export function useGetProfilesHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>(GetProfilesHierarchyDocument, options);
        }
export type GetProfilesHierarchyQueryHookResult = ReturnType<typeof useGetProfilesHierarchyQuery>;
export type GetProfilesHierarchyLazyQueryHookResult = ReturnType<typeof useGetProfilesHierarchyLazyQuery>;
export type GetProfilesHierarchySuspenseQueryHookResult = ReturnType<typeof useGetProfilesHierarchySuspenseQuery>;
export type GetProfilesHierarchyQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfilesHierarchyQuery, GraphqlTypes.GetProfilesHierarchyQueryVariables>;
export const GpPositionDetailsForCaseDocument = gql`
    query GpPositionDetailsForCase($arenaId: Int!, $caseId: Int!) {
  caseLinkedPositions(arenaId: $arenaId, caseId: $caseId) {
    positionId
    entityName
    profileName
  }
}
    `;

/**
 * __useGpPositionDetailsForCaseQuery__
 *
 * To run a query within a React component, call `useGpPositionDetailsForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGpPositionDetailsForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpPositionDetailsForCaseQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGpPositionDetailsForCaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables> & ({ variables: GraphqlTypes.GpPositionDetailsForCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>(GpPositionDetailsForCaseDocument, options);
      }
export function useGpPositionDetailsForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>(GpPositionDetailsForCaseDocument, options);
        }
// @ts-ignore
export function useGpPositionDetailsForCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>;
export function useGpPositionDetailsForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpPositionDetailsForCaseQuery | undefined, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>;
export function useGpPositionDetailsForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>(GpPositionDetailsForCaseDocument, options);
        }
export type GpPositionDetailsForCaseQueryHookResult = ReturnType<typeof useGpPositionDetailsForCaseQuery>;
export type GpPositionDetailsForCaseLazyQueryHookResult = ReturnType<typeof useGpPositionDetailsForCaseLazyQuery>;
export type GpPositionDetailsForCaseSuspenseQueryHookResult = ReturnType<typeof useGpPositionDetailsForCaseSuspenseQuery>;
export type GpPositionDetailsForCaseQueryResult = Apollo.QueryResult<GraphqlTypes.GpPositionDetailsForCaseQuery, GraphqlTypes.GpPositionDetailsForCaseQueryVariables>;
export const GpComplianceAuditLogDocument = gql`
    query GpComplianceAuditLog($arenaId: Int!, $entityIds: [Int!], $positionId: Int, $caseTypes: [ComplianceCaseTypeEnum!], $dateFrom: DateTime, $dateTo: DateTime, $limit: Int! = 10, $offset: Int! = 0) {
  complianceAuditLog(
    arenaId: $arenaId
    entityIds: $entityIds
    positionId: $positionId
    caseTypes: $caseTypes
    dateFrom: $dateFrom
    dateTo: $dateTo
    limit: $limit
    offset: $offset
  ) {
    totalCount
    hasMore
    events {
      caseId
      caseType
      eventType
      caseSubStatus
      createdAt
      auditTag
      caseProfileName
      entityNames
      positionCount
    }
  }
}
    `;

/**
 * __useGpComplianceAuditLogQuery__
 *
 * To run a query within a React component, call `useGpComplianceAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGpComplianceAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpComplianceAuditLogQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityIds: // value for 'entityIds'
 *      positionId: // value for 'positionId'
 *      caseTypes: // value for 'caseTypes'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGpComplianceAuditLogQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables> & ({ variables: GraphqlTypes.GpComplianceAuditLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>(GpComplianceAuditLogDocument, options);
      }
export function useGpComplianceAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>(GpComplianceAuditLogDocument, options);
        }
// @ts-ignore
export function useGpComplianceAuditLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>;
export function useGpComplianceAuditLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpComplianceAuditLogQuery | undefined, GraphqlTypes.GpComplianceAuditLogQueryVariables>;
export function useGpComplianceAuditLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>(GpComplianceAuditLogDocument, options);
        }
export type GpComplianceAuditLogQueryHookResult = ReturnType<typeof useGpComplianceAuditLogQuery>;
export type GpComplianceAuditLogLazyQueryHookResult = ReturnType<typeof useGpComplianceAuditLogLazyQuery>;
export type GpComplianceAuditLogSuspenseQueryHookResult = ReturnType<typeof useGpComplianceAuditLogSuspenseQuery>;
export type GpComplianceAuditLogQueryResult = Apollo.QueryResult<GraphqlTypes.GpComplianceAuditLogQuery, GraphqlTypes.GpComplianceAuditLogQueryVariables>;
export const GetInvestmentEntitiesDocument = gql`
    query GetInvestmentEntities($arenaId: Int!, $after: String, $first: Int, $entities: [ID!], $sort: [AccountObjectTypeSortEnum], $compliancePrograms: [String!]) {
  investmentEntities(
    after: $after
    first: $first
    filters: {ids: $entities, compliancePrograms: $compliancePrograms}
    sort: $sort
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        name
        positionCount
        complianceSummary(arenaId: $arenaId) {
          compliantCount
          lpSubmissionCount
          juniperSquareReviewCount
          pendingDivestmentCount
          totalOnboardedPositions
          lastActivity
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetInvestmentEntitiesQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      entities: // value for 'entities'
 *      sort: // value for 'sort'
 *      compliancePrograms: // value for 'compliancePrograms'
 *   },
 * });
 */
export function useGetInvestmentEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>(GetInvestmentEntitiesDocument, options);
      }
export function useGetInvestmentEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>(GetInvestmentEntitiesDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>;
export function useGetInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesQuery | undefined, GraphqlTypes.GetInvestmentEntitiesQueryVariables>;
export function useGetInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>(GetInvestmentEntitiesDocument, options);
        }
export type GetInvestmentEntitiesQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesQuery>;
export type GetInvestmentEntitiesLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesLazyQuery>;
export type GetInvestmentEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesSuspenseQuery>;
export type GetInvestmentEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesQuery, GraphqlTypes.GetInvestmentEntitiesQueryVariables>;
export const GetAllInvestmentEntitiesDocument = gql`
    query GetAllInvestmentEntities($compliancePrograms: [String!]) {
  investmentEntities(filters: {compliancePrograms: $compliancePrograms}) {
    edges {
      node {
        id
        name
      }
    }
    count
  }
}
    `;

/**
 * __useGetAllInvestmentEntitiesQuery__
 *
 * To run a query within a React component, call `useGetAllInvestmentEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInvestmentEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInvestmentEntitiesQuery({
 *   variables: {
 *      compliancePrograms: // value for 'compliancePrograms'
 *   },
 * });
 */
export function useGetAllInvestmentEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>(GetAllInvestmentEntitiesDocument, options);
      }
export function useGetAllInvestmentEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>(GetAllInvestmentEntitiesDocument, options);
        }
// @ts-ignore
export function useGetAllInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>;
export function useGetAllInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllInvestmentEntitiesQuery | undefined, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>;
export function useGetAllInvestmentEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>(GetAllInvestmentEntitiesDocument, options);
        }
export type GetAllInvestmentEntitiesQueryHookResult = ReturnType<typeof useGetAllInvestmentEntitiesQuery>;
export type GetAllInvestmentEntitiesLazyQueryHookResult = ReturnType<typeof useGetAllInvestmentEntitiesLazyQuery>;
export type GetAllInvestmentEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetAllInvestmentEntitiesSuspenseQuery>;
export type GetAllInvestmentEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllInvestmentEntitiesQuery, GraphqlTypes.GetAllInvestmentEntitiesQueryVariables>;
export const GpPositionDetailsForEntityDocument = gql`
    query GpPositionDetailsForEntity($arenaId: Int!, $entityId: Int!, $positionIds: [Int!], $page: Int! = 0, $sort: CompliancePositionSort = null) {
  compliancePositions(
    arenaId: $arenaId
    entityId: $entityId
    positionIds: $positionIds
    page: $page
    sort: $sort
  ) {
    positionId
    programId
    entityName
    amlKycStatus
    onboardingDate
    lastActivity
    screeningStatus
    riskRating {
      positionRiskRating
    }
    investingProfile {
      id
      firstName
      middleName
      lastName
      legalName
      accountType
      complianceObjectType
    }
  }
}
    `;

/**
 * __useGpPositionDetailsForEntityQuery__
 *
 * To run a query within a React component, call `useGpPositionDetailsForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGpPositionDetailsForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpPositionDetailsForEntityQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      positionIds: // value for 'positionIds'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGpPositionDetailsForEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables> & ({ variables: GraphqlTypes.GpPositionDetailsForEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>(GpPositionDetailsForEntityDocument, options);
      }
export function useGpPositionDetailsForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>(GpPositionDetailsForEntityDocument, options);
        }
// @ts-ignore
export function useGpPositionDetailsForEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>;
export function useGpPositionDetailsForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpPositionDetailsForEntityQuery | undefined, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>;
export function useGpPositionDetailsForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>(GpPositionDetailsForEntityDocument, options);
        }
export type GpPositionDetailsForEntityQueryHookResult = ReturnType<typeof useGpPositionDetailsForEntityQuery>;
export type GpPositionDetailsForEntityLazyQueryHookResult = ReturnType<typeof useGpPositionDetailsForEntityLazyQuery>;
export type GpPositionDetailsForEntitySuspenseQueryHookResult = ReturnType<typeof useGpPositionDetailsForEntitySuspenseQuery>;
export type GpPositionDetailsForEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GpPositionDetailsForEntityQuery, GraphqlTypes.GpPositionDetailsForEntityQueryVariables>;
export const GetAllGpPositionDetailsDocument = gql`
    query GetAllGpPositionDetails($arenaId: Int!, $entityId: Int!) {
  compliancePositions(arenaId: $arenaId, entityId: $entityId) {
    positionId
    investingProfile {
      id
      firstName
      middleName
      lastName
      legalName
      accountType
      complianceObjectType
    }
  }
}
    `;

/**
 * __useGetAllGpPositionDetailsQuery__
 *
 * To run a query within a React component, call `useGetAllGpPositionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGpPositionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGpPositionDetailsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetAllGpPositionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables> & ({ variables: GraphqlTypes.GetAllGpPositionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>(GetAllGpPositionDetailsDocument, options);
      }
export function useGetAllGpPositionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>(GetAllGpPositionDetailsDocument, options);
        }
// @ts-ignore
export function useGetAllGpPositionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>;
export function useGetAllGpPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllGpPositionDetailsQuery | undefined, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>;
export function useGetAllGpPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>(GetAllGpPositionDetailsDocument, options);
        }
export type GetAllGpPositionDetailsQueryHookResult = ReturnType<typeof useGetAllGpPositionDetailsQuery>;
export type GetAllGpPositionDetailsLazyQueryHookResult = ReturnType<typeof useGetAllGpPositionDetailsLazyQuery>;
export type GetAllGpPositionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAllGpPositionDetailsSuspenseQuery>;
export type GetAllGpPositionDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllGpPositionDetailsQuery, GraphqlTypes.GetAllGpPositionDetailsQueryVariables>;
export const GpPositionPageDetailsDocument = gql`
    query GpPositionPageDetails($arenaId: Int!, $entityId: Int!, $positionId: Int!) {
  compliancePositions(
    arenaId: $arenaId
    entityId: $entityId
    positionIds: [$positionId]
    onboardingComplete: true
  ) {
    positionId
    programId
    entityName
    screeningStatus
    pepExposure
    domicile {
      name
      isoCode
    }
    riskRating {
      positionRiskRating
      investorRiskRating
      paymentBeneficiaryRiskRating
      paymentAccountRiskRating
    }
    profileRefresh {
      hasActiveEscalation
      schedule {
        nextRefreshDueDate
      }
    }
    documentRefresh {
      hasActiveEscalation
      schedules {
        expiryDate
      }
    }
    investingProfile {
      ...PositionProfile
    }
    childProfiles {
      ...PositionProfile
    }
  }
}
    ${PositionProfileFragmentDoc}`;

/**
 * __useGpPositionPageDetailsQuery__
 *
 * To run a query within a React component, call `useGpPositionPageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGpPositionPageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpPositionPageDetailsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGpPositionPageDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables> & ({ variables: GraphqlTypes.GpPositionPageDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>(GpPositionPageDetailsDocument, options);
      }
export function useGpPositionPageDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>(GpPositionPageDetailsDocument, options);
        }
// @ts-ignore
export function useGpPositionPageDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>;
export function useGpPositionPageDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpPositionPageDetailsQuery | undefined, GraphqlTypes.GpPositionPageDetailsQueryVariables>;
export function useGpPositionPageDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>(GpPositionPageDetailsDocument, options);
        }
export type GpPositionPageDetailsQueryHookResult = ReturnType<typeof useGpPositionPageDetailsQuery>;
export type GpPositionPageDetailsLazyQueryHookResult = ReturnType<typeof useGpPositionPageDetailsLazyQuery>;
export type GpPositionPageDetailsSuspenseQueryHookResult = ReturnType<typeof useGpPositionPageDetailsSuspenseQuery>;
export type GpPositionPageDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GpPositionPageDetailsQuery, GraphqlTypes.GpPositionPageDetailsQueryVariables>;
export const GpCreateScreeningReportDocument = gql`
    mutation GpCreateScreeningReport($arenaId: Int!, $positionIds: [Int!]!) {
  createComplianceScreeningReport(arenaId: $arenaId, positionIds: $positionIds) {
    id
    status
    errorMsg
  }
}
    `;
export type GpCreateScreeningReportMutationFn = Apollo.MutationFunction<GraphqlTypes.GpCreateScreeningReportMutation, GraphqlTypes.GpCreateScreeningReportMutationVariables>;

/**
 * __useGpCreateScreeningReportMutation__
 *
 * To run a mutation, you first call `useGpCreateScreeningReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGpCreateScreeningReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gpCreateScreeningReportMutation, { data, loading, error }] = useGpCreateScreeningReportMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function useGpCreateScreeningReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GpCreateScreeningReportMutation, GraphqlTypes.GpCreateScreeningReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GpCreateScreeningReportMutation, GraphqlTypes.GpCreateScreeningReportMutationVariables>(GpCreateScreeningReportDocument, options);
      }
export type GpCreateScreeningReportMutationHookResult = ReturnType<typeof useGpCreateScreeningReportMutation>;
export type GpCreateScreeningReportMutationResult = Apollo.MutationResult<GraphqlTypes.GpCreateScreeningReportMutation>;
export type GpCreateScreeningReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GpCreateScreeningReportMutation, GraphqlTypes.GpCreateScreeningReportMutationVariables>;
export const GpGetComplianceReportDocument = gql`
    query GpGetComplianceReport($arenaId: Int!, $id: Int!) {
  getComplianceScreeningReport(arenaId: $arenaId, id: $id) {
    id
    reportType
    status
    s3Url
    errorMsg
  }
}
    `;

/**
 * __useGpGetComplianceReportQuery__
 *
 * To run a query within a React component, call `useGpGetComplianceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGpGetComplianceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpGetComplianceReportQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGpGetComplianceReportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables> & ({ variables: GraphqlTypes.GpGetComplianceReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>(GpGetComplianceReportDocument, options);
      }
export function useGpGetComplianceReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>(GpGetComplianceReportDocument, options);
        }
// @ts-ignore
export function useGpGetComplianceReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>;
export function useGpGetComplianceReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GpGetComplianceReportQuery | undefined, GraphqlTypes.GpGetComplianceReportQueryVariables>;
export function useGpGetComplianceReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>(GpGetComplianceReportDocument, options);
        }
export type GpGetComplianceReportQueryHookResult = ReturnType<typeof useGpGetComplianceReportQuery>;
export type GpGetComplianceReportLazyQueryHookResult = ReturnType<typeof useGpGetComplianceReportLazyQuery>;
export type GpGetComplianceReportSuspenseQueryHookResult = ReturnType<typeof useGpGetComplianceReportSuspenseQuery>;
export type GpGetComplianceReportQueryResult = Apollo.QueryResult<GraphqlTypes.GpGetComplianceReportQuery, GraphqlTypes.GpGetComplianceReportQueryVariables>;
export const GetPositionNameInfoDocument = gql`
    query GetPositionNameInfo($positionFilters: PositionFilterInput!) {
  positions(positionFilters: $positionFilters) {
    edges {
      node {
        id
        account {
          name
        }
        investmentEntity {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPositionNameInfoQuery__
 *
 * To run a query within a React component, call `useGetPositionNameInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionNameInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionNameInfoQuery({
 *   variables: {
 *      positionFilters: // value for 'positionFilters'
 *   },
 * });
 */
export function useGetPositionNameInfoQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables> & ({ variables: GraphqlTypes.GetPositionNameInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>(GetPositionNameInfoDocument, options);
      }
export function useGetPositionNameInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>(GetPositionNameInfoDocument, options);
        }
// @ts-ignore
export function useGetPositionNameInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>;
export function useGetPositionNameInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionNameInfoQuery | undefined, GraphqlTypes.GetPositionNameInfoQueryVariables>;
export function useGetPositionNameInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>(GetPositionNameInfoDocument, options);
        }
export type GetPositionNameInfoQueryHookResult = ReturnType<typeof useGetPositionNameInfoQuery>;
export type GetPositionNameInfoLazyQueryHookResult = ReturnType<typeof useGetPositionNameInfoLazyQuery>;
export type GetPositionNameInfoSuspenseQueryHookResult = ReturnType<typeof useGetPositionNameInfoSuspenseQuery>;
export type GetPositionNameInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionNameInfoQuery, GraphqlTypes.GetPositionNameInfoQueryVariables>;
export const GetPositionsStatusDocument = gql`
    query GetPositionsStatus($arenaId: Int!, $entityId: Int = null) {
  complianceBucketCounts(arenaId: $arenaId, entityId: $entityId) {
    compliantCount
    lpSubmissionCount
    juniperSquareReviewCount
    pendingDivestmentCount
    totalOnboardedPositions
  }
}
    `;

/**
 * __useGetPositionsStatusQuery__
 *
 * To run a query within a React component, call `useGetPositionsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsStatusQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetPositionsStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables> & ({ variables: GraphqlTypes.GetPositionsStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>(GetPositionsStatusDocument, options);
      }
export function useGetPositionsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>(GetPositionsStatusDocument, options);
        }
// @ts-ignore
export function useGetPositionsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>;
export function useGetPositionsStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsStatusQuery | undefined, GraphqlTypes.GetPositionsStatusQueryVariables>;
export function useGetPositionsStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>(GetPositionsStatusDocument, options);
        }
export type GetPositionsStatusQueryHookResult = ReturnType<typeof useGetPositionsStatusQuery>;
export type GetPositionsStatusLazyQueryHookResult = ReturnType<typeof useGetPositionsStatusLazyQuery>;
export type GetPositionsStatusSuspenseQueryHookResult = ReturnType<typeof useGetPositionsStatusSuspenseQuery>;
export type GetPositionsStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionsStatusQuery, GraphqlTypes.GetPositionsStatusQueryVariables>;
export const GetTotalPositionsInEntityDocument = gql`
    query GetTotalPositionsInEntity($positionFilters: PositionFilterInput!) {
  positions(positionFilters: $positionFilters) {
    count
  }
}
    `;

/**
 * __useGetTotalPositionsInEntityQuery__
 *
 * To run a query within a React component, call `useGetTotalPositionsInEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalPositionsInEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalPositionsInEntityQuery({
 *   variables: {
 *      positionFilters: // value for 'positionFilters'
 *   },
 * });
 */
export function useGetTotalPositionsInEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables> & ({ variables: GraphqlTypes.GetTotalPositionsInEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>(GetTotalPositionsInEntityDocument, options);
      }
export function useGetTotalPositionsInEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>(GetTotalPositionsInEntityDocument, options);
        }
// @ts-ignore
export function useGetTotalPositionsInEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>;
export function useGetTotalPositionsInEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTotalPositionsInEntityQuery | undefined, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>;
export function useGetTotalPositionsInEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>(GetTotalPositionsInEntityDocument, options);
        }
export type GetTotalPositionsInEntityQueryHookResult = ReturnType<typeof useGetTotalPositionsInEntityQuery>;
export type GetTotalPositionsInEntityLazyQueryHookResult = ReturnType<typeof useGetTotalPositionsInEntityLazyQuery>;
export type GetTotalPositionsInEntitySuspenseQueryHookResult = ReturnType<typeof useGetTotalPositionsInEntitySuspenseQuery>;
export type GetTotalPositionsInEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetTotalPositionsInEntityQuery, GraphqlTypes.GetTotalPositionsInEntityQueryVariables>;
export const GetProfileDetailsDocument = gql`
    query GetProfileDetails($profileId: Int!, $caseId: Int!) {
  complianceProfile(id: $profileId) {
    ...ProfileDetails
    parentRelationships {
      ...ProfileRelationshipDetails
    }
  }
}
    ${ProfileDetailsFragmentDoc}
${ProfileRelationshipDetailsFragmentDoc}`;

/**
 * __useGetProfileDetailsQuery__
 *
 * To run a query within a React component, call `useGetProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileDetailsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetProfileDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables> & ({ variables: GraphqlTypes.GetProfileDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>(GetProfileDetailsDocument, options);
      }
export function useGetProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>(GetProfileDetailsDocument, options);
        }
// @ts-ignore
export function useGetProfileDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>;
export function useGetProfileDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileDetailsQuery | undefined, GraphqlTypes.GetProfileDetailsQueryVariables>;
export function useGetProfileDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>(GetProfileDetailsDocument, options);
        }
export type GetProfileDetailsQueryHookResult = ReturnType<typeof useGetProfileDetailsQuery>;
export type GetProfileDetailsLazyQueryHookResult = ReturnType<typeof useGetProfileDetailsLazyQuery>;
export type GetProfileDetailsSuspenseQueryHookResult = ReturnType<typeof useGetProfileDetailsSuspenseQuery>;
export type GetProfileDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>;
export const PublicComplianceGeneratePresignedUrlsDocument = gql`
    mutation publicComplianceGeneratePresignedUrls($emailToken: String!, $input: [CompliancePresignedUrlInput!]!) {
  publicComplianceGeneratePresignedUrls(emailToken: $emailToken, input: $input) {
    s3Url
    objectKey
    fileName
  }
}
    `;
export type PublicComplianceGeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutation, GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutationVariables>;

/**
 * __usePublicComplianceGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `usePublicComplianceGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicComplianceGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicComplianceGeneratePresignedUrlsMutation, { data, loading, error }] = usePublicComplianceGeneratePresignedUrlsMutation({
 *   variables: {
 *      emailToken: // value for 'emailToken'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicComplianceGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutation, GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutation, GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutationVariables>(PublicComplianceGeneratePresignedUrlsDocument, options);
      }
export type PublicComplianceGeneratePresignedUrlsMutationHookResult = ReturnType<typeof usePublicComplianceGeneratePresignedUrlsMutation>;
export type PublicComplianceGeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutation>;
export type PublicComplianceGeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutation, GraphqlTypes.PublicComplianceGeneratePresignedUrlsMutationVariables>;
export const PublicComplianceUploadDocumentDocument = gql`
    mutation publicComplianceUploadDocument($emailToken: String!, $documents: [DocumentInfoInput!]!) {
  publicComplianceUploadDocument(emailToken: $emailToken, documents: $documents) {
    id
    name
    documentPurposeId
    documentPurpose {
      baseType
    }
    metadata {
      key
      value
      type
    }
  }
}
    `;
export type PublicComplianceUploadDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.PublicComplianceUploadDocumentMutation, GraphqlTypes.PublicComplianceUploadDocumentMutationVariables>;

/**
 * __usePublicComplianceUploadDocumentMutation__
 *
 * To run a mutation, you first call `usePublicComplianceUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicComplianceUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicComplianceUploadDocumentMutation, { data, loading, error }] = usePublicComplianceUploadDocumentMutation({
 *   variables: {
 *      emailToken: // value for 'emailToken'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function usePublicComplianceUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublicComplianceUploadDocumentMutation, GraphqlTypes.PublicComplianceUploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublicComplianceUploadDocumentMutation, GraphqlTypes.PublicComplianceUploadDocumentMutationVariables>(PublicComplianceUploadDocumentDocument, options);
      }
export type PublicComplianceUploadDocumentMutationHookResult = ReturnType<typeof usePublicComplianceUploadDocumentMutation>;
export type PublicComplianceUploadDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.PublicComplianceUploadDocumentMutation>;
export type PublicComplianceUploadDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublicComplianceUploadDocumentMutation, GraphqlTypes.PublicComplianceUploadDocumentMutationVariables>;
export const PublicComplianceDeleteDocumentDocument = gql`
    mutation publicComplianceDeleteDocument($emailToken: String!, $documentId: Int!) {
  publicComplianceDeleteDocument(emailToken: $emailToken, documentId: $documentId)
}
    `;
export type PublicComplianceDeleteDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.PublicComplianceDeleteDocumentMutation, GraphqlTypes.PublicComplianceDeleteDocumentMutationVariables>;

/**
 * __usePublicComplianceDeleteDocumentMutation__
 *
 * To run a mutation, you first call `usePublicComplianceDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicComplianceDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicComplianceDeleteDocumentMutation, { data, loading, error }] = usePublicComplianceDeleteDocumentMutation({
 *   variables: {
 *      emailToken: // value for 'emailToken'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function usePublicComplianceDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PublicComplianceDeleteDocumentMutation, GraphqlTypes.PublicComplianceDeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PublicComplianceDeleteDocumentMutation, GraphqlTypes.PublicComplianceDeleteDocumentMutationVariables>(PublicComplianceDeleteDocumentDocument, options);
      }
export type PublicComplianceDeleteDocumentMutationHookResult = ReturnType<typeof usePublicComplianceDeleteDocumentMutation>;
export type PublicComplianceDeleteDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.PublicComplianceDeleteDocumentMutation>;
export type PublicComplianceDeleteDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PublicComplianceDeleteDocumentMutation, GraphqlTypes.PublicComplianceDeleteDocumentMutationVariables>;
export const GetDocumentUploadInviteDetailsDocument = gql`
    query GetDocumentUploadInviteDetails($emailToken: String!) {
  publicGetDocumentUploadInviteDetails(emailToken: $emailToken) {
    subscriberName
    subscriberEmailAddress
    emailInviteTimestamp
    message
    caseId
    caseType
    profileId
    complianceProfile {
      profileName
    }
    status
    rulesEngine {
      ...DocumentTypesDetails
    }
    uploadedDocuments {
      id
      name
      baseType
      subType
    }
  }
}
    ${DocumentTypesDetailsFragmentDoc}`;

/**
 * __useGetDocumentUploadInviteDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentUploadInviteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUploadInviteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUploadInviteDetailsQuery({
 *   variables: {
 *      emailToken: // value for 'emailToken'
 *   },
 * });
 */
export function useGetDocumentUploadInviteDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables> & ({ variables: GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>(GetDocumentUploadInviteDetailsDocument, options);
      }
export function useGetDocumentUploadInviteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>(GetDocumentUploadInviteDetailsDocument, options);
        }
// @ts-ignore
export function useGetDocumentUploadInviteDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>;
export function useGetDocumentUploadInviteDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentUploadInviteDetailsQuery | undefined, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>;
export function useGetDocumentUploadInviteDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>(GetDocumentUploadInviteDetailsDocument, options);
        }
export type GetDocumentUploadInviteDetailsQueryHookResult = ReturnType<typeof useGetDocumentUploadInviteDetailsQuery>;
export type GetDocumentUploadInviteDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentUploadInviteDetailsLazyQuery>;
export type GetDocumentUploadInviteDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentUploadInviteDetailsSuspenseQuery>;
export type GetDocumentUploadInviteDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentUploadInviteDetailsQuery, GraphqlTypes.GetDocumentUploadInviteDetailsQueryVariables>;
export const InviteToUploadDocument = gql`
    mutation inviteToUpload($profileId: Int!, $caseId: Int!, $emailId: String!, $message: String!) {
  inviteToUploadDocuments(
    input: {emailAddress: $emailId, message: $message, profileId: $profileId, caseId: $caseId}
  ) {
    id
    message
    emailAddress
    status
    documentUploadDate
    emailInviteDateSent
  }
}
    `;
export type InviteToUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.InviteToUploadMutation, GraphqlTypes.InviteToUploadMutationVariables>;

/**
 * __useInviteToUploadMutation__
 *
 * To run a mutation, you first call `useInviteToUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToUploadMutation, { data, loading, error }] = useInviteToUploadMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      caseId: // value for 'caseId'
 *      emailId: // value for 'emailId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useInviteToUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.InviteToUploadMutation, GraphqlTypes.InviteToUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.InviteToUploadMutation, GraphqlTypes.InviteToUploadMutationVariables>(InviteToUploadDocument, options);
      }
export type InviteToUploadMutationHookResult = ReturnType<typeof useInviteToUploadMutation>;
export type InviteToUploadMutationResult = Apollo.MutationResult<GraphqlTypes.InviteToUploadMutation>;
export type InviteToUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.InviteToUploadMutation, GraphqlTypes.InviteToUploadMutationVariables>;
export const CancelUploadInviteDocument = gql`
    mutation cancelUploadInvite($inviteId: Int!) {
  cancelDocumentUploadInvite(input: {documentUploadInviteId: $inviteId}) {
    id
  }
}
    `;
export type CancelUploadInviteMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelUploadInviteMutation, GraphqlTypes.CancelUploadInviteMutationVariables>;

/**
 * __useCancelUploadInviteMutation__
 *
 * To run a mutation, you first call `useCancelUploadInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUploadInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUploadInviteMutation, { data, loading, error }] = useCancelUploadInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useCancelUploadInviteMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelUploadInviteMutation, GraphqlTypes.CancelUploadInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelUploadInviteMutation, GraphqlTypes.CancelUploadInviteMutationVariables>(CancelUploadInviteDocument, options);
      }
export type CancelUploadInviteMutationHookResult = ReturnType<typeof useCancelUploadInviteMutation>;
export type CancelUploadInviteMutationResult = Apollo.MutationResult<GraphqlTypes.CancelUploadInviteMutation>;
export type CancelUploadInviteMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelUploadInviteMutation, GraphqlTypes.CancelUploadInviteMutationVariables>;
export const ResendUploadInviteDocument = gql`
    mutation resendUploadInvite($inviteId: Int!) {
  resendDocumentUploadInvite(input: {documentUploadInviteId: $inviteId}) {
    id
  }
}
    `;
export type ResendUploadInviteMutationFn = Apollo.MutationFunction<GraphqlTypes.ResendUploadInviteMutation, GraphqlTypes.ResendUploadInviteMutationVariables>;

/**
 * __useResendUploadInviteMutation__
 *
 * To run a mutation, you first call `useResendUploadInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUploadInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUploadInviteMutation, { data, loading, error }] = useResendUploadInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useResendUploadInviteMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResendUploadInviteMutation, GraphqlTypes.ResendUploadInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResendUploadInviteMutation, GraphqlTypes.ResendUploadInviteMutationVariables>(ResendUploadInviteDocument, options);
      }
export type ResendUploadInviteMutationHookResult = ReturnType<typeof useResendUploadInviteMutation>;
export type ResendUploadInviteMutationResult = Apollo.MutationResult<GraphqlTypes.ResendUploadInviteMutation>;
export type ResendUploadInviteMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResendUploadInviteMutation, GraphqlTypes.ResendUploadInviteMutationVariables>;
export const GetDocumentDetailsDocument = gql`
    query GetDocumentDetails($profileId: Int!, $caseId: Int!) {
  complianceProfile(id: $profileId) {
    ...ProfileDetails
    documents {
      ...DocumentsDetails
    }
    rulesEngine(caseId: $caseId) {
      ...DocumentTypesDetails
    }
    complianceCases {
      isInvestingProfile
      caseId
      complianceCase {
        id
        investingProfile {
          ...ProfileDetails
          rulesEngine(caseId: $caseId) {
            ...DocumentTypesDetails
          }
        }
      }
    }
    inviteToUploadDocumentsDetails(caseId: $caseId) {
      id
      emailAddress
      message
      status
      emailInviteDateSent
      documentUploadDate
    }
  }
}
    ${ProfileDetailsFragmentDoc}
${DocumentsDetailsFragmentDoc}
${DocumentTypesDetailsFragmentDoc}`;

/**
 * __useGetDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables> & ({ variables: GraphqlTypes.GetDocumentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
      }
export function useGetDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
// @ts-ignore
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>;
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentDetailsQuery | undefined, GraphqlTypes.GetDocumentDetailsQueryVariables>;
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
export type GetDocumentDetailsQueryHookResult = ReturnType<typeof useGetDocumentDetailsQuery>;
export type GetDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsLazyQuery>;
export type GetDocumentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDetailsSuspenseQuery>;
export type GetDocumentDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>;
export const CreateDocumentsDocument = gql`
    mutation createDocuments($caseId: Int!, $documents: [DocumentInfoInput!]!) {
  createComplianceDocuments(caseId: $caseId, documents: $documents) {
    id
    name
    documentPurpose {
      baseType
    }
  }
}
    `;
export type CreateDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>;

/**
 * __useCreateDocumentsMutation__
 *
 * To run a mutation, you first call `useCreateDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentsMutation, { data, loading, error }] = useCreateDocumentsMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useCreateDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>(CreateDocumentsDocument, options);
      }
export type CreateDocumentsMutationHookResult = ReturnType<typeof useCreateDocumentsMutation>;
export type CreateDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDocumentsMutation>;
export type CreateDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($caseId: Int!, $documentId: Int!) {
  deleteComplianceDocument(caseId: $caseId, documentId: $documentId)
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>;
export const UpdateDocumentDetailsDocument = gql`
    mutation UpdateDocumentDetails($caseId: Int!, $documentId: Int!, $updateInfo: DocumentUpdateInfoInput!) {
  updateComplianceDocumentDetails(
    caseId: $caseId
    documentId: $documentId
    updateInfo: $updateInfo
  ) {
    id
    profileId
    metadata {
      key
      value
      type
    }
    documentPurpose {
      baseType
    }
  }
}
    `;
export type UpdateDocumentDetailsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDocumentDetailsMutation, GraphqlTypes.UpdateDocumentDetailsMutationVariables>;

/**
 * __useUpdateDocumentDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentDetailsMutation, { data, loading, error }] = useUpdateDocumentDetailsMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documentId: // value for 'documentId'
 *      updateInfo: // value for 'updateInfo'
 *   },
 * });
 */
export function useUpdateDocumentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDocumentDetailsMutation, GraphqlTypes.UpdateDocumentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDocumentDetailsMutation, GraphqlTypes.UpdateDocumentDetailsMutationVariables>(UpdateDocumentDetailsDocument, options);
      }
export type UpdateDocumentDetailsMutationHookResult = ReturnType<typeof useUpdateDocumentDetailsMutation>;
export type UpdateDocumentDetailsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDocumentDetailsMutation>;
export type UpdateDocumentDetailsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDocumentDetailsMutation, GraphqlTypes.UpdateDocumentDetailsMutationVariables>;
export const UpdateDocumentsCompletedDocument = gql`
    mutation updateDocumentsCompleted($caseId: Int!, $profileId: Int!, $documentsCompleted: Boolean) {
  updateCaseProfileOwnersOrControllersCompleted(
    caseId: $caseId
    profileId: $profileId
    documentsCompleted: $documentsCompleted
  )
}
    `;
export type UpdateDocumentsCompletedMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDocumentsCompletedMutation, GraphqlTypes.UpdateDocumentsCompletedMutationVariables>;

/**
 * __useUpdateDocumentsCompletedMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentsCompletedMutation, { data, loading, error }] = useUpdateDocumentsCompletedMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      profileId: // value for 'profileId'
 *      documentsCompleted: // value for 'documentsCompleted'
 *   },
 * });
 */
export function useUpdateDocumentsCompletedMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDocumentsCompletedMutation, GraphqlTypes.UpdateDocumentsCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDocumentsCompletedMutation, GraphqlTypes.UpdateDocumentsCompletedMutationVariables>(UpdateDocumentsCompletedDocument, options);
      }
export type UpdateDocumentsCompletedMutationHookResult = ReturnType<typeof useUpdateDocumentsCompletedMutation>;
export type UpdateDocumentsCompletedMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDocumentsCompletedMutation>;
export type UpdateDocumentsCompletedMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDocumentsCompletedMutation, GraphqlTypes.UpdateDocumentsCompletedMutationVariables>;
export const CreateIndividualProfileDocument = gql`
    mutation CreateIndividualProfile($arenaAccessId: Int, $data: ComplianceIndividualProfileInput!, $parentProfileId: Int) {
  createIndividualProfile(
    arenaAccessId: $arenaAccessId
    data: $data
    parentProfileId: $parentProfileId
  ) {
    id
  }
}
    `;
export type CreateIndividualProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>;

/**
 * __useCreateIndividualProfileMutation__
 *
 * To run a mutation, you first call `useCreateIndividualProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndividualProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndividualProfileMutation, { data, loading, error }] = useCreateIndividualProfileMutation({
 *   variables: {
 *      arenaAccessId: // value for 'arenaAccessId'
 *      data: // value for 'data'
 *      parentProfileId: // value for 'parentProfileId'
 *   },
 * });
 */
export function useCreateIndividualProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>(CreateIndividualProfileDocument, options);
      }
export type CreateIndividualProfileMutationHookResult = ReturnType<typeof useCreateIndividualProfileMutation>;
export type CreateIndividualProfileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateIndividualProfileMutation>;
export type CreateIndividualProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>;
export const CreateInstitutionProfileDocument = gql`
    mutation CreateInstitutionProfile($arenaAccessId: Int, $data: ComplianceInstitutionProfileInput!, $parentProfileId: Int) {
  createInstitutionProfile(
    arenaAccessId: $arenaAccessId
    data: $data
    parentProfileId: $parentProfileId
  ) {
    id
  }
}
    `;
export type CreateInstitutionProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateInstitutionProfileMutation, GraphqlTypes.CreateInstitutionProfileMutationVariables>;

/**
 * __useCreateInstitutionProfileMutation__
 *
 * To run a mutation, you first call `useCreateInstitutionProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstitutionProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstitutionProfileMutation, { data, loading, error }] = useCreateInstitutionProfileMutation({
 *   variables: {
 *      arenaAccessId: // value for 'arenaAccessId'
 *      data: // value for 'data'
 *      parentProfileId: // value for 'parentProfileId'
 *   },
 * });
 */
export function useCreateInstitutionProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateInstitutionProfileMutation, GraphqlTypes.CreateInstitutionProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateInstitutionProfileMutation, GraphqlTypes.CreateInstitutionProfileMutationVariables>(CreateInstitutionProfileDocument, options);
      }
export type CreateInstitutionProfileMutationHookResult = ReturnType<typeof useCreateInstitutionProfileMutation>;
export type CreateInstitutionProfileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateInstitutionProfileMutation>;
export type CreateInstitutionProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateInstitutionProfileMutation, GraphqlTypes.CreateInstitutionProfileMutationVariables>;
export const CreateJointProfileDocument = gql`
    mutation CreateJointProfile($arenaAccessId: Int, $data: ComplianceJointProfileInput!, $parentProfileId: Int) {
  createJointProfile(
    arenaAccessId: $arenaAccessId
    data: $data
    parentProfileId: $parentProfileId
  ) {
    id
  }
}
    `;
export type CreateJointProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>;

/**
 * __useCreateJointProfileMutation__
 *
 * To run a mutation, you first call `useCreateJointProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJointProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJointProfileMutation, { data, loading, error }] = useCreateJointProfileMutation({
 *   variables: {
 *      arenaAccessId: // value for 'arenaAccessId'
 *      data: // value for 'data'
 *      parentProfileId: // value for 'parentProfileId'
 *   },
 * });
 */
export function useCreateJointProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>(CreateJointProfileDocument, options);
      }
export type CreateJointProfileMutationHookResult = ReturnType<typeof useCreateJointProfileMutation>;
export type CreateJointProfileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateJointProfileMutation>;
export type CreateJointProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>;
export const UpdateDeclaredIndividualDocument = gql`
    mutation UpdateDeclaredIndividual($profileId: Int!, $parentProfileId: Int, $data: ComplianceIndividualProfileInput!) {
  updateIndividualProfile(
    data: $data
    profileId: $profileId
    parentProfileId: $parentProfileId
  ) {
    id
  }
}
    `;
export type UpdateDeclaredIndividualMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDeclaredIndividualMutation, GraphqlTypes.UpdateDeclaredIndividualMutationVariables>;

/**
 * __useUpdateDeclaredIndividualMutation__
 *
 * To run a mutation, you first call `useUpdateDeclaredIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeclaredIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeclaredIndividualMutation, { data, loading, error }] = useUpdateDeclaredIndividualMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      parentProfileId: // value for 'parentProfileId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDeclaredIndividualMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDeclaredIndividualMutation, GraphqlTypes.UpdateDeclaredIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDeclaredIndividualMutation, GraphqlTypes.UpdateDeclaredIndividualMutationVariables>(UpdateDeclaredIndividualDocument, options);
      }
export type UpdateDeclaredIndividualMutationHookResult = ReturnType<typeof useUpdateDeclaredIndividualMutation>;
export type UpdateDeclaredIndividualMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDeclaredIndividualMutation>;
export type UpdateDeclaredIndividualMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDeclaredIndividualMutation, GraphqlTypes.UpdateDeclaredIndividualMutationVariables>;
export const UpdateDeclaredInstitutionDocument = gql`
    mutation UpdateDeclaredInstitution($profileId: Int!, $parentProfileId: Int, $data: ComplianceInstitutionProfileInput!) {
  updateInstitutionProfile(
    data: $data
    profileId: $profileId
    parentProfileId: $parentProfileId
  ) {
    id
  }
}
    `;
export type UpdateDeclaredInstitutionMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDeclaredInstitutionMutation, GraphqlTypes.UpdateDeclaredInstitutionMutationVariables>;

/**
 * __useUpdateDeclaredInstitutionMutation__
 *
 * To run a mutation, you first call `useUpdateDeclaredInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeclaredInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeclaredInstitutionMutation, { data, loading, error }] = useUpdateDeclaredInstitutionMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      parentProfileId: // value for 'parentProfileId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDeclaredInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDeclaredInstitutionMutation, GraphqlTypes.UpdateDeclaredInstitutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDeclaredInstitutionMutation, GraphqlTypes.UpdateDeclaredInstitutionMutationVariables>(UpdateDeclaredInstitutionDocument, options);
      }
export type UpdateDeclaredInstitutionMutationHookResult = ReturnType<typeof useUpdateDeclaredInstitutionMutation>;
export type UpdateDeclaredInstitutionMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDeclaredInstitutionMutation>;
export type UpdateDeclaredInstitutionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDeclaredInstitutionMutation, GraphqlTypes.UpdateDeclaredInstitutionMutationVariables>;
export const UpdateDeclaredJointDocument = gql`
    mutation UpdateDeclaredJoint($profileId: Int!, $parentProfileId: Int, $data: ComplianceJointProfileInput!) {
  updateJointProfile(
    data: $data
    profileId: $profileId
    parentProfileId: $parentProfileId
  ) {
    id
  }
}
    `;
export type UpdateDeclaredJointMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDeclaredJointMutation, GraphqlTypes.UpdateDeclaredJointMutationVariables>;

/**
 * __useUpdateDeclaredJointMutation__
 *
 * To run a mutation, you first call `useUpdateDeclaredJointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeclaredJointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeclaredJointMutation, { data, loading, error }] = useUpdateDeclaredJointMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      parentProfileId: // value for 'parentProfileId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDeclaredJointMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDeclaredJointMutation, GraphqlTypes.UpdateDeclaredJointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDeclaredJointMutation, GraphqlTypes.UpdateDeclaredJointMutationVariables>(UpdateDeclaredJointDocument, options);
      }
export type UpdateDeclaredJointMutationHookResult = ReturnType<typeof useUpdateDeclaredJointMutation>;
export type UpdateDeclaredJointMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDeclaredJointMutation>;
export type UpdateDeclaredJointMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDeclaredJointMutation, GraphqlTypes.UpdateDeclaredJointMutationVariables>;
export const GetProfilesForCaseDocument = gql`
    query GetProfilesForCase($caseId: Int!) {
  complianceCase(caseId: $caseId) {
    id
    investingProfile {
      ...ProfileDetails
      amlEntityTypeQuestions(caseId: $caseId) {
        id
        text
        subText
        isDefault
        targetAmlEntityTypeId
      }
      documentRefreshSchedules {
        documentId
        expiryDate
      }
      parentRelationships {
        ...ProfileRelationshipDetails
      }
      childOwnershipThreshold(caseId: $caseId)
      beneficialOwners {
        ...ProfileRelationshipDetails
      }
      controllingPersons {
        ...ProfileRelationshipDetails
      }
      documents {
        ...DocumentsDetails
      }
      rulesEngine(caseId: $caseId) {
        ...DocumentTypesDetails
      }
      dateOfBirth
      amlEntityTypeId
      caseDataEntryStatus(caseId: $caseId) {
        ownersCompleted
        controllersCompleted
        documentsCompleted
      }
    }
    profiles {
      ...ProfileDetails
      parentRelationships {
        ...ProfileRelationshipDetails
      }
      beneficialOwners {
        ...ProfileRelationshipDetails
      }
      controllingPersons {
        ...ProfileRelationshipDetails
      }
      childOwnershipThreshold(caseId: $caseId)
      documents {
        ...DocumentsDetails
      }
      rulesEngine(caseId: $caseId) {
        ...DocumentTypesDetails
      }
    }
  }
}
    ${ProfileDetailsFragmentDoc}
${ProfileRelationshipDetailsFragmentDoc}
${DocumentsDetailsFragmentDoc}
${DocumentTypesDetailsFragmentDoc}`;

/**
 * __useGetProfilesForCaseQuery__
 *
 * To run a query within a React component, call `useGetProfilesForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesForCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetProfilesForCaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables> & ({ variables: GraphqlTypes.GetProfilesForCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>(GetProfilesForCaseDocument, options);
      }
export function useGetProfilesForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>(GetProfilesForCaseDocument, options);
        }
// @ts-ignore
export function useGetProfilesForCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>;
export function useGetProfilesForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesForCaseQuery | undefined, GraphqlTypes.GetProfilesForCaseQueryVariables>;
export function useGetProfilesForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>(GetProfilesForCaseDocument, options);
        }
export type GetProfilesForCaseQueryHookResult = ReturnType<typeof useGetProfilesForCaseQuery>;
export type GetProfilesForCaseLazyQueryHookResult = ReturnType<typeof useGetProfilesForCaseLazyQuery>;
export type GetProfilesForCaseSuspenseQueryHookResult = ReturnType<typeof useGetProfilesForCaseSuspenseQuery>;
export type GetProfilesForCaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>;
export const GetComplianceCaseDocument = gql`
    query GetComplianceCase($caseId: Int!) {
  complianceCase(caseId: $caseId) {
    id
    caseType
    createdAt
    readonly
    metaData
    programId
    externalObjects {
      id
      objectId
      objectType
      objectTypeEnum
      service
      name
    }
    investingProfile {
      id
      accountType
      complianceObjectType
      amlEntityTypeId
      metaData
      legalName
      caseDataEntryStatus(caseId: $caseId) {
        id
        ownersCompleted
        controllersCompleted
        documentsCompleted
      }
    }
  }
}
    `;

/**
 * __useGetComplianceCaseQuery__
 *
 * To run a query within a React component, call `useGetComplianceCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetComplianceCaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>(GetComplianceCaseDocument, options);
      }
export function useGetComplianceCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>(GetComplianceCaseDocument, options);
        }
// @ts-ignore
export function useGetComplianceCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>;
export function useGetComplianceCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseQuery | undefined, GraphqlTypes.GetComplianceCaseQueryVariables>;
export function useGetComplianceCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>(GetComplianceCaseDocument, options);
        }
export type GetComplianceCaseQueryHookResult = ReturnType<typeof useGetComplianceCaseQuery>;
export type GetComplianceCaseLazyQueryHookResult = ReturnType<typeof useGetComplianceCaseLazyQuery>;
export type GetComplianceCaseSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCaseSuspenseQuery>;
export type GetComplianceCaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>;
export const SubscriptionSubmitIdentificationKycDocument = gql`
    mutation SubscriptionSubmitIdentificationKyc($subscriptionId: Int!, $arenaId: Int!) {
  subscriptionSubmitIdentificationKyc(
    subscriptionId: $subscriptionId
    arenaId: $arenaId
  ) {
    __typename
    ...MutationErrorFragment
    ... on SubscriptionV2ObjectType {
      id
      latestValidatedStep
    }
  }
}
    ${MutationErrorFragmentFragmentDoc}`;
export type SubscriptionSubmitIdentificationKycMutationFn = Apollo.MutationFunction<GraphqlTypes.SubscriptionSubmitIdentificationKycMutation, GraphqlTypes.SubscriptionSubmitIdentificationKycMutationVariables>;

/**
 * __useSubscriptionSubmitIdentificationKycMutation__
 *
 * To run a mutation, you first call `useSubscriptionSubmitIdentificationKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionSubmitIdentificationKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionSubmitIdentificationKycMutation, { data, loading, error }] = useSubscriptionSubmitIdentificationKycMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useSubscriptionSubmitIdentificationKycMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubscriptionSubmitIdentificationKycMutation, GraphqlTypes.SubscriptionSubmitIdentificationKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubscriptionSubmitIdentificationKycMutation, GraphqlTypes.SubscriptionSubmitIdentificationKycMutationVariables>(SubscriptionSubmitIdentificationKycDocument, options);
      }
export type SubscriptionSubmitIdentificationKycMutationHookResult = ReturnType<typeof useSubscriptionSubmitIdentificationKycMutation>;
export type SubscriptionSubmitIdentificationKycMutationResult = Apollo.MutationResult<GraphqlTypes.SubscriptionSubmitIdentificationKycMutation>;
export type SubscriptionSubmitIdentificationKycMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubscriptionSubmitIdentificationKycMutation, GraphqlTypes.SubscriptionSubmitIdentificationKycMutationVariables>;
export const GetComplianceCasesByObjectIdDocument = gql`
    query GetComplianceCasesByObjectId($arenaId: Int!, $externalObject: ExternalObjectInput!) {
  complianceCasesByObjectId(arenaId: $arenaId, externalObject: $externalObject) {
    id
    caseType
    origin
    createdAt
    readonly
    metaData
    programId
    externalObjects {
      id
      objectId
      objectType
      objectTypeEnum
      service
      name
    }
    investingProfile {
      id
      accountType
      amlEntityTypeId
      metaData
      caseDataEntryStatus(arenaId: $arenaId, externalObject: $externalObject) {
        id
        ownersCompleted
        controllersCompleted
        documentsCompleted
      }
    }
  }
}
    `;

/**
 * __useGetComplianceCasesByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetComplianceCasesByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCasesByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCasesByObjectIdQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      externalObject: // value for 'externalObject'
 *   },
 * });
 */
export function useGetComplianceCasesByObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>(GetComplianceCasesByObjectIdDocument, options);
      }
export function useGetComplianceCasesByObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>(GetComplianceCasesByObjectIdDocument, options);
        }
// @ts-ignore
export function useGetComplianceCasesByObjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>;
export function useGetComplianceCasesByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesByObjectIdQuery | undefined, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>;
export function useGetComplianceCasesByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>(GetComplianceCasesByObjectIdDocument, options);
        }
export type GetComplianceCasesByObjectIdQueryHookResult = ReturnType<typeof useGetComplianceCasesByObjectIdQuery>;
export type GetComplianceCasesByObjectIdLazyQueryHookResult = ReturnType<typeof useGetComplianceCasesByObjectIdLazyQuery>;
export type GetComplianceCasesByObjectIdSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCasesByObjectIdSuspenseQuery>;
export type GetComplianceCasesByObjectIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>;
export const PerformActionDocument = gql`
    mutation performAction($caseId: Int!, $action: ComplianceCaseAction!) {
  performAction(caseId: $caseId, action: $action) {
    __typename
  }
}
    `;
export type PerformActionMutationFn = Apollo.MutationFunction<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>;

/**
 * __usePerformActionMutation__
 *
 * To run a mutation, you first call `usePerformActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performActionMutation, { data, loading, error }] = usePerformActionMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function usePerformActionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>(PerformActionDocument, options);
      }
export type PerformActionMutationHookResult = ReturnType<typeof usePerformActionMutation>;
export type PerformActionMutationResult = Apollo.MutationResult<GraphqlTypes.PerformActionMutation>;
export type PerformActionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>;
export const GetUserComplianceCasesDocument = gql`
    query GetUserComplianceCases($caseType: ComplianceCaseTypeEnum!, $externalObject: ExternalObjectInput!, $auditTag: ComplianceCaseAuditTagType!) {
  userAccessibleComplianceCases(
    caseType: $caseType
    externalObject: $externalObject
  ) {
    id
    caseType
    status
    subStatus
    createdAt
    metaData
    programId
    position {
      id
      arena {
        name
      }
      investmentEntity {
        name
      }
      account {
        name
      }
    }
    events(tag: $auditTag) {
      tag
      createdAt
    }
    investingProfile {
      id
      accountType
      metaData
      amlEntityTypeId
      firstName
      middleName
      lastName
      legalName
      complianceObjectType
      refreshSchedule {
        id
        profileGuid
        lastRefreshDate
        nextRefreshDueDate
      }
      documentRefreshSchedules {
        documentId
        expiryDate
      }
    }
  }
}
    `;

/**
 * __useGetUserComplianceCasesQuery__
 *
 * To run a query within a React component, call `useGetUserComplianceCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserComplianceCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserComplianceCasesQuery({
 *   variables: {
 *      caseType: // value for 'caseType'
 *      externalObject: // value for 'externalObject'
 *      auditTag: // value for 'auditTag'
 *   },
 * });
 */
export function useGetUserComplianceCasesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables> & ({ variables: GraphqlTypes.GetUserComplianceCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>(GetUserComplianceCasesDocument, options);
      }
export function useGetUserComplianceCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>(GetUserComplianceCasesDocument, options);
        }
// @ts-ignore
export function useGetUserComplianceCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>;
export function useGetUserComplianceCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserComplianceCasesQuery | undefined, GraphqlTypes.GetUserComplianceCasesQueryVariables>;
export function useGetUserComplianceCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>(GetUserComplianceCasesDocument, options);
        }
export type GetUserComplianceCasesQueryHookResult = ReturnType<typeof useGetUserComplianceCasesQuery>;
export type GetUserComplianceCasesLazyQueryHookResult = ReturnType<typeof useGetUserComplianceCasesLazyQuery>;
export type GetUserComplianceCasesSuspenseQueryHookResult = ReturnType<typeof useGetUserComplianceCasesSuspenseQuery>;
export type GetUserComplianceCasesQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserComplianceCasesQuery, GraphqlTypes.GetUserComplianceCasesQueryVariables>;
export const ComplianceGeneratePresignedUrlsDocument = gql`
    mutation complianceGeneratePresignedUrls($urlGeneratorInput: [CompliancePresignedUrlInput!]!, $caseId: Int) {
  complianceGeneratePresignedUrls(
    urlGeneratorInput: $urlGeneratorInput
    caseId: $caseId
  ) {
    s3Url
    objectKey
    fileName
  }
}
    `;
export type ComplianceGeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>;

/**
 * __useComplianceGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useComplianceGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComplianceGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [complianceGeneratePresignedUrlsMutation, { data, loading, error }] = useComplianceGeneratePresignedUrlsMutation({
 *   variables: {
 *      urlGeneratorInput: // value for 'urlGeneratorInput'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useComplianceGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>(ComplianceGeneratePresignedUrlsDocument, options);
      }
export type ComplianceGeneratePresignedUrlsMutationHookResult = ReturnType<typeof useComplianceGeneratePresignedUrlsMutation>;
export type ComplianceGeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation>;
export type ComplianceGeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>;